import create from 'zustand';

export type AlgoliaAnalyticsState = {
    initialized: boolean;
    indexName: string;
    setInitialized: (initialized: boolean) => void;
    setIndexName: (indexName: string) => void;
};

export const useAlgoliaAnalyticsState = create<AlgoliaAnalyticsState>((set) => ({
    initialized: false,
    indexName: '',
    setInitialized: (initialized: boolean) => {
        set(() => ({
            initialized: initialized,
        }));
    },
    setIndexName: (indexName: string) => {
        set(() => ({
            indexName: indexName,
        }));
    },
}));
